import React from "react";
import numberFormatter from "../functions/numberFormatter";

const FormatNumber = ({ number = 0, format = "long" }) => {
  return (
    <span>{format === "short" ? numberFormatter.formatShort(number) : numberFormatter.formatLong(number)}</span>
  );
};

export default FormatNumber;